import { addDocument } from '../../services/firestore-service';

export const addItem = (item) => {
    return (dispatch, getState) => {
        dispatch({ type: 'ADD_ITEM', item })
    }
}

export const submitOrder = (data) => {
    return (dispatch, getState) => {
        const state = getState();
        const payload = {
            ...data, 
            items: state.cart.items,
            created_at: new Date().toISOString(),
            read: false
        }
        addDocument('orders', payload).then(() => {
            dispatch({ type: 'SUBMIT_ORDER', payload});
        }).catch((error) => {
            dispatch({ type: 'SUBMIT_ORDER_FAILED', error});
        })
    }
}

export const submitContactForm = (data) => {
    return () => {
        addDocument('contactForms', { 
            ...data,
            read: false,
            created_at: new Date()
        }).catch((error) => {
            console.error(error);
        })
    }
}

export const updateItemQuantity = (data) => {
    return (dispatch) => {
        dispatch({ type: 'UPDATE_ITEM_QUANTITY', data });
    }
}

export const removeItem = (data) => {
    return (dispatch) => {
        dispatch({ type: 'REMOVE_ITEM', data });
    }
}
